import React from 'react';

const FiltersForm = ({ filters, setFilters, clearFilters }) => (
  <div className="row mb-3">
    <div className="col">
      <label className="form-label">Organization Host</label>
      <input
        type="text"
        className="form-control"
        value={filters.organization_hostname}
        onChange={(e) => setFilters({ ...filters, organization_hostname: e.target.value })}
      />
    </div>
    <div className="col">
      <label className="form-label">Peer Host</label>
      <input
        type="text"
        className="form-control"
        value={filters.peer_hostname}
        onChange={(e) => setFilters({ ...filters, peer_hostname: e.target.value })}
      />
    </div>
    <div className="col">
      <label className="form-label">Alert Description</label>
      <input
        type="text"
        className="form-control"
        value={filters.description}
        onChange={(e) => setFilters({ ...filters, description: e.target.value })}
      />
    </div>
    {(filters.organization_ip || filters.organization_hostname || filters.peer_hostname || filters.description) && (
      <div className="col d-flex align-items-end">
        <button className="btn btn-secondary" onClick={clearFilters}>
          Clear Filters
        </button>
      </div>
    )}
  </div>
);

export default FiltersForm;
